
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.061 6.061L17.94 3.94l-5.938 5.94-5.94-5.94L3.94 6.061l5.94 5.94-5.94 5.938 2.122 2.122 5.94-5.94 5.938 5.94 2.122-2.122-5.94-5.938 5.94-5.94z","fill":"currentColor"}})])
          )
        }
      }
    